<template>
    <div
        :style="getIndicatorStyles"
        class="widget-color flex items-center gap-2 leading-normal"
    >
        <slot name="prefix">
            <div
                v-if="label"
                class="text-main-sm main-text-color flex-grow"
            >
                {{ label }}
            </div>
        </slot>
        <div class="w-22 flex-shrink-0">
            <RedesignBaseInput
                v-model="model"
                :size="size === 'medium' ? 'small' : size"
                class="w-full"
            />
        </div>
        <color-picker
            v-model="model"
            color-format="hex"
            :size="size"
            :predefine="predefinedColors"
            :style="getIndicatorStyles"
            class="inline-flex justify-center items-center"
        />
    </div>
</template>

<script setup lang="ts">
import ColorPicker from '@/components/Common/ColorPicker.vue'
import { computed, watch } from 'vue'
import RedesignBaseInput from '@/components/RedesignBaseComponents/Inputs/RedesignBaseInput.vue'
import { isDarkColor } from '@/helpers/colors'
// import { isLightOrDark } from '@/helpers/colors'

const COLOR_ICON = {
    light: 'black',
    dark: 'white'
}

const props = defineProps<{
    value?: string | null
    option?: string
    label?: string
    size?: 'medium' | 'small' | 'mini'
    predefinedColors?: Array<string>
}>()

const emit = defineEmits<{
    (e: 'update:value', value: string): void
    (e: 'input', value: string): void
}>()

// const model = useVModel(props, 'value', emit, { eventName: 'input' })

const model = computed({
    get () {
        return props.value
    },
    set (val) {
        emit('input', val)
        emit('update:value', val)
    }
})

const getIndicatorStyles = computed(() => {
    if (!model.value) {
        return {
            '--color': COLOR_ICON['light']
        }
    }
    const colorIsDark = isDarkColor(model.value)
    const color = colorIsDark ? COLOR_ICON['dark'] : COLOR_ICON['light']
    return {
        '--color': color
    }
})

watch(
    model,
    (val) => {
        emit('update:value', val)
    }
)
</script>

<style lang="scss">
.widget-color {
    .el-input__inner {
        @apply text-xs font-medium;
    }

    .el-color-picker__trigger {
        @apply w-8 h-8 rounded-full p-0.5 border-transparent;
        .el-color-picker__color {
            border: none;
        }

        .el-color-picker__icon {
            word-break: break-all;

            &:before {
                font-weight: 500;
            }
        }

        .el-icon-arrow-down:before,
        .el-icon-close:before {
            font-family: VC-icon;
            font-weight: 500;
            content: '\e921';
            font-size: 18px;
            color: var(--color, #BEC2C9);
        }

        .el-color-picker__color-inner {
            @apply rounded;
            border: 1px solid var(--ui-lines, #BEC2C9);
            border-radius: 50%;
            //color: var(--gray-550);

        }

        &:hover {
            //.el-icon-arrow-down:before,
            //.el-icon-close:before {
            //    //color: var(--primary-color);
            //}
            border: 2px solid var(--primary-color);

            //.el-color-picker__color-inner {
            //    //border: 1px solid var(--primary-color);
            //}
        }
    }

    .el-color-picker--medium {
        .el-color-picker__trigger {
            @apply w-10 h-10;
        }
    }

    .el-color-dropdown__link-btn {
        padding: 0 !important;
    }

    //.el-color-picker__color-inner {
    //    background: var(--secondaryBgColor-color) !important;
    //    color: var(--mainTextColor-color) !important;
    //}
}

.rtl {
    .el-color-picker__panel .el-color-predefine {
        .el-color-predefine__color-selector {
            @apply mx-1;
        }
    }

    .el-color-dropdown__main-wrapper {
        .el-color-hue-slider {
            float: left !important;
        }
    }

    .el-color-dropdown__btns {
        .el-button--default {
            @apply mx-2;
        }
    }
}
</style>
